(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mo-recipe-hub"]) return;
  try {
    
  function initializeRecipeHubs(){
    document.querySelectorAll('[data-recipe-hub]').forEach(function(hub){
      if(hub.dataset.initialized)return;
      hub.dataset.initialized='true';
      var input=hub.querySelector('[data-recipe-search]');
      var cards=Array.from(hub.querySelectorAll('[data-recipe-card]'));
      var count=hub.querySelector('[data-recipe-count]');
      var empty=hub.querySelector('[data-recipe-empty]');
      function normalize(value){return value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');}
      input.addEventListener('input',function(){
        var terms=normalize(input.value.trim()).split(/\s+/).filter(Boolean);
        var visible=0;
        cards.forEach(function(card){
          var text=normalize(card.dataset.search);
          var matches=terms.every(function(term){return text.includes(term);});
          card.hidden=!matches;
          if(matches)visible+=1;
        });
        count.textContent=visible;
        empty.hidden=visible!==0;
      });
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initializeRecipeHubs);}else{initializeRecipeHubs();}
  document.addEventListener('shopify:section:load',initializeRecipeHubs);

  } catch(e) { console.error(e); }
})();
})();
